import { images } from "@/assets";
import { routes } from "@/routes/utils";

export const cardList = [
    {
        title: "Pre Defined",
        bgImg: images.predefined_template,
        className: "bg-[#37445F]",
        backgroundSize: "100% 100%",
        link: `${routes.predefinedTemplate}`,
    },
    {
        title: "Custom",
        bgImg: images.custom_template,
        className: "bg-[#37445F]",
        backgroundSize: "100% 100%",
        link: `${routes.customTemplate}/${routes.stateLevelTnc}`,
    },

];
